<ng-container *ngIf="resources.includes('*') && !locations.length && !isLoading">
  <mat-card class="allLocations"
    >All Locations Selected <sn-icon fontSet="fal" fontIcon="fa-circle-check"></sn-icon
  ></mat-card>
</ng-container>
<ng-container *ngIf="!resources.includes('*') && locations.length && !isLoading">
  <mat-card class="mat-elevation-z2" *ngFor="let location of locations">
    {{ location.name }}
  </mat-card>
</ng-container>
<ng-container *ngIf="!resources.includes('*') && !locations.length && isLoading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>
